export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10567.e5a1f3ef.jpg";